import { FAQPage, WithContext } from 'schema-dts';

export type MainEntity = {
  '@type': 'Question' | 'Answer';
  name: string;
  acceptedAnswer: {
    '@type': 'Answer';
    text: string;
  };
};

export const faqJSONLD = (mainEntity: MainEntity[]): WithContext<FAQPage> => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity
});
